import { appRoutes } from './shared/routes/app-routes';
export const navItems = [
  {
    name: 'Comercial',
    icon: 'briefcase',
    children: [
      {
        permission: 'CLIENT',
        name: 'Clientes',
        url: appRoutes.clients.list().join('/'),
        icon: 'clipboard-list'
      },
      {
        permission: 'BANK',
        name: 'Bancos',
        url: appRoutes.banks.list().join('/'),
        icon: 'landmark'
      },
      {
        permission: 'CLIENT',
        name: 'Representantes',
        url: appRoutes.representatives.list().join('/'),
        icon: 'user'
      },
      {
        permission: 'CLIENT',
        name: 'Gestão de Pedidos',
        url: appRoutes.orders.list().join('/'),
        icon: 'circle-dot'
      }, {
        permission: 'CLIENT',
        name: 'Cadastros de Clientes',
        url: appRoutes.customerRegistry.list().join('/'),
        icon: 'sticky-note'
      }
    ]
  }, {
    name: 'Operacional',
    icon: 'network',
    children: [
      {
        permission: 'MASTEREVENT',
        name: 'Grupos de Eventos',
        url: appRoutes.eventGroups.list().join('/'),
        icon: 'flag'
      }, {
        permission: 'EVENT',
        name: 'Eventos',
        url: appRoutes.events.list().join('/'),
        icon: 'flag'
      }, {
        permission: 'TECHNICIAN',
        name: 'Técnicos',
        url: appRoutes.technicians.list().join('/'),
        icon: 'concierge-bell'
      }, {
        permission: 'PRODUCT_CATEGORY',
        name: 'Categorias de Produtos',
        url: appRoutes.productCategories.list().join('/'),
        icon: 'layout-grid'
      }, {
        permission: 'PRODUCT',
        name: 'Produtos',
        url: appRoutes.products.list().join('/'),
        icon: 'menu'
      }, {
        permission: 'ADDITIONALITEM',
        name: 'Adicionais de Produto',
        url: appRoutes.additionalItems.list().join('/'),
        icon: 'receipt'
      }, {
        permission: 'PRINTERDEVICE',
        name: 'Impressoras',
        url: appRoutes.printers.list().join('/'),
        icon: 'printer-check'
      }, {
        permission: 'POINT_OF_SALE',
        name: 'Pontos de Venda',
        url: appRoutes.salePoints.list().join('/'),
        icon: 'badge-dollar-sign'
      }, {
        permission: 'PAYMENT_TYPE',
        name: 'Formas de Pagamento',
        url: appRoutes.paymentTypes.list().join('/'),
        icon: 'credit-card'
      }, {
        permission: 'DEVICE',
        name: 'Dispositivos',
        url: appRoutes.devices.list().join('/'),
        icon: 'phone'
      }, {
        permission: 'APPLICATION_ROLE',
        name: 'Permissões do App',
        url: appRoutes.appPermissions.list().join('/'),
        icon: 'phone-call'
      }, {
        permission: 'NCM',
        name: 'NCM',
        url: appRoutes.ncms.list().join('/'),
        icon: 'phone-call'
      }
    ]
  }, {
    name: 'Administrativo',
    icon: 'wrench',
    children: [
      {
        permission: 'ROLE',
        name: 'Permissões',
        url: appRoutes.permissions.list().join('/'),
        icon: 'shield-check'
      }, {
        permission: 'USER',
        name: 'Usuários',
        url: appRoutes.users.list().join('/'),
        icon: 'user'
      }, {
        permission: 'PENDENCY',
        name: 'Pendências',
        url: appRoutes.pendencies.list().join('/'),
        icon: 'triangle-alert'
      }, {
        permission: 'NOTIFICATION',
        name: 'Notificações',
        url: appRoutes.notifications.list().join('/'),
        icon: 'bell'
      }, {
        permission: 'ORGANIZATION',
        name: 'Organizações',
        url: appRoutes.organizations.list().join('/'),
        icon: 'building-2'
      }, {
        permission: 'PUBLICACCESSTOKEN',
        name: 'Acessos API',
        url: appRoutes.apiAccess.list().join('/'),
        icon: 'settings'
      }, {
        permission: 'ORGANIZATIONPARTNER',
        name: 'Parceiros',
        url: appRoutes.partners.list().join('/'),
        icon: 'users'
      }
    ]
  }, {
    name: 'Financeiro',
    icon: 'dollar-sign',
    children: [
      {
        permission: 'ACQUIRERFEE',
        name: 'Cadastro de Taxas',
        url: appRoutes.fees.list().join('/'),
        icon: 'chart-column'
      }, {
        permission: 'ACQUIRERCOSTRATE',
        name: 'Taxas do Adquirente',
        url: appRoutes.acquirerRates.list().join('/'),
        icon: 'percent'
      }, {
        permission: 'PUBLICACQUIRERTRANSACTION',
        name: 'Conciliação',
        url: appRoutes.reconciliations.list().join('/'),
        icon: 'circle-check'
      }, {
        permission: 'EVENTCLOSING',
        name: 'Fechamento',
        url: appRoutes.closures.list().join('/'),
        icon: 'hand-coins'
      }, {
        permission: 'EVENTCLOSINGTAXINFORMATION',
        name: 'Controle Fiscal',
        url: appRoutes.taxControl.list().join('/'),
        icon: 'receipt-text'
      }, {
        permission: 'ATTENDEEREFUND',
        name: 'Reembolsos',
        url: appRoutes.refunds.list().join('/'),
        icon: 'badge-dollar-sign'
      }, {
        permission: 'CLIENT',
        name: 'Repasses',
        url: appRoutes.transfers.list().join('/'),
        icon: 'loader-circle'
      }, {
        permission: 'CLIENT',
        name: 'Adiantamentos',
        url: appRoutes.advances.list().join('/'),
        icon: 'credit-card'
      }, {
        permission: 'CLIENT',
        name: 'Metas de Faturamento',
        url: appRoutes.revenueGoals.list().join('/'),
        icon: 'dollar-sign'
      }, {
        permission: 'CLIENT',
        name: 'Transações',
        url: appRoutes.transactions.list().join('/'),
        icon: 'arrow-left-right'
      }, {
        permission: 'EVENTCLOSINGTAXINFORMATION',
        name: 'Não Conciliadas',
        url: appRoutes.ownerlessTransactions.list().join('/'),
        icon: 'circle-alert'
      }, {
        permission: 'CLIENT',
        name: 'Dashboard',
        url: appRoutes.financialDashboard.home().join('/'),
        icon: 'menu'
      }
    ]
  }, {
    name: 'Bilheteria',
    icon: 'ticket',
    children: [
      {
        permission: 'TICKETOFFICESALEPOINT',
        name: 'Pontos de Venda',
        url: appRoutes.ticketSalePoints.list().join('/'),
        icon: 'badge-dollar-sign'
      }
    ]
  }, {
    name: 'Inventário',
    icon: 'sticky-note',
    children: [
      {
        permission: 'DEVICE_RENTALL',
        name: 'Aluguel de Dispositivos',
        url: appRoutes.rentals.list().join('/'),
        icon: 'monitor'
      },
      {
        permission: 'DEVICE_RENTALL',
        name: 'Aluguéis Inconsistentes',
        url: appRoutes.rentals.inconsistent().join('/'),
        icon: 'circle-alert'
      },
      {
        permission: 'PHYSICAL_DEVICE',
        name: 'Dispositivos Físicos',
        url: appRoutes.physicalDevices.list().join('/'),
        icon: 'smartphone'
      },
      {
        permission: 'DEVICE_RENTALL',
        name: 'Dashboard',
        url: appRoutes.inventoryDashboard.home().join('/'),
        icon: 'menu'
      }
    ]
  }
];
